import { useState } from "react";
import { X, Bell } from "lucide-react";

export default function ReminderModal({ onSend, onClose, loading }) {
  const [days, setDays] = useState("3");
  const [type, setType] = useState("vencimento_boleto");

  function handleSend() {
    onSend({ days_before: parseInt(days), template_type: type });
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-sm" data-testid="reminder-modal">
        <div className="bg-white rounded-2xl shadow-2xl p-6">
          <div className="flex items-center gap-2 mb-4">
            <div className="p-2 bg-amber-100 rounded-lg"><Bell className="w-5 h-5 text-amber-700" /></div>
            <h3 className="text-lg font-bold text-[#0A2F3D]">Disparar Lembretes</h3>
          </div>
          <p className="text-sm text-gray-500 mb-4">Enviar lembretes para pagamentos que vencem nos proximos dias.</p>
          <div className="space-y-3 mb-5">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Vencimento em ate (dias)</label>
              <select value={days} onChange={function(e) { setDays(e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-amber-500/30"
                data-testid="reminder-days">
                <option value="1">1 dia</option>
                <option value="3">3 dias</option>
                <option value="5">5 dias</option>
                <option value="7">7 dias</option>
                <option value="15">15 dias</option>
                <option value="30">30 dias</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Tipo de lembrete</label>
              <select value={type} onChange={function(e) { setType(e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-amber-500/30"
                data-testid="reminder-type">
                <option value="vencimento_boleto">Vencimento Boleto</option>
                <option value="vencimento_cartao">Verificar Limite Cartao</option>
              </select>
            </div>
          </div>
          <div className="flex gap-3">
            <button onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
            <button onClick={handleSend} disabled={loading}
              className="flex-1 px-4 py-2.5 bg-amber-500 text-white rounded-xl text-sm font-medium hover:bg-amber-600 disabled:opacity-50"
              data-testid="reminder-send-button">
              {loading ? "Enviando..." : "Disparar Lembretes"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
